<template>
  <div class="columns store-form">
    <div class="column pb-0">
      <h2 class="store-form__title">店家資訊</h2>
      <b-field
        horizontal
        :message="storeNameErrorMessage"
        :type="{ 'is-danger': invalidName }">
        <template #label>
          <span class="required">店名</span>
        </template>
        <b-input
          v-model="currentStore.store_detail.name"
          name="name"
          expanded
          @input="v$.currentStore.store_detail.name.$touch" />
      </b-field>
      <b-field
        horizontal
        class="store-form__address-field"
        label="地址">
        <b-select
          v-model="currentStore.store_detail.city"
          placeholder="縣市"
          @input="updateDistrict">
          <option
            v-for="city in districtInfo"
            :value="city.name"
            :key="city.name">
            {{ city.name}}
          </option>
        </b-select>
        <b-select
          v-model="currentStore.store_detail.dist"
          placeholder="行政區"
          :disabled="!currentDistrict.length">
          <option
            v-for="district in currentDistrict"
            :value="district.name"
            :key="district.name">
            {{ district.name}}
          </option>
        </b-select>
        <b-input
          v-model="currentStore.store_detail.address"
          name="address"
          placeholder="地址"
          :disabled="!currentStore.store_detail.city"
          expanded />
      </b-field>
      <b-field horizontal
        label="Email"
        message="可填入多組Email，團購結束時系統將自動寄送訂購項目統計報表。">
        <b-taginput
          v-model="currentStore.emails"
          :before-adding="beforeAddEmail"
          ref="taginput"
        >
          <template #selected="props">
            <b-tag
              v-for="(tag, index) in props.tags"
              :key="`email-tag-${tag}-${index}`"
              closable
              rounded
              type="is-primary-light"
              @close="$refs.taginput.removeTag(index, $event)"
            >
              {{ tag }}
            </b-tag>
          </template>
        </b-taginput>
      </b-field>
      <b-field
        horizontal
        class="store-form__method-field"
        :message="paymentMethodErrorMessage"
        :type="{ 'is-danger': invalidPaymentMethod }">
        <template #label>
          <span class="required">訂購方式</span>
        </template>
        <b-checkbox
          v-model="paymentMethods"
          native-value="phone"
          @input="syncPaymentMethods('phone')">
          <img src="@/assets/images/telephone.svg" alt="電話圖示">
          <span>電話</span>
        </b-checkbox>
        <b-checkbox
          v-model="paymentMethods"
          native-value="iding"
          @input="syncPaymentMethods('iding')">
          <img src="@/assets/images/iding-logo.svg" alt="愛點餐圖示">
          <span>微碧愛點餐</span>
        </b-checkbox>
        <b-checkbox
          v-model="paymentMethods"
          native-value="line"
          @input="syncPaymentMethods('line')">
          <img src="@/assets/images/line-logo.svg" alt="LINE 圖示">
          <span>官方帳號</span>
        </b-checkbox>
        <b-checkbox
          v-model="paymentMethods"
          native-value="facebook"
          @input="syncPaymentMethods('facebook')">
          <img src="@/assets/images/facebook-logo.svg" alt="Facebook 圖示">
          <span>Facebook</span>
        </b-checkbox>
      </b-field>
      <div
        v-if="paymentMethods.length"
        class="store-form__method-field--detail">
        <b-field
          v-for="method in paymentMethods"
          horizontal
          :key="`method-${method}`">
          <b-field
            :label="orderMethodMapping[method].label"
            :type="{
              'is-danger': v$.currentStore.store_order_way[
                orderMethodMapping[method].key
              ].$invalid
            }"
            :message="
              paymentMethodErrors[orderMethodMapping[method].key].$message"
            horizontal>
            <b-input
              v-model="currentStore.store_order_way[orderMethodMapping[method].key]"
              :placeholder="orderMethodMapping[method].placeholder"
              @input="v$.currentStore.store_order_way[orderMethodMapping[method].key].$touch" />
          </b-field>
        </b-field>
      </div>
      <b-field
        horizontal
        class="store-form__leave-field"
        label="公休日">
        <b-checkbox
          v-model="closedDays"
          :native-value="1">
          星期一
        </b-checkbox>
        <b-checkbox
          v-model="closedDays"
          :native-value="2">
          星期二
        </b-checkbox>
        <b-checkbox
          v-model="closedDays"
          :native-value="3">
          星期三
        </b-checkbox>
        <b-checkbox
          v-model="closedDays"
          :native-value="4">
          星期四
        </b-checkbox>
        <b-checkbox
          v-model="closedDays"
          :native-value="5">
          星期五
        </b-checkbox>
        <b-checkbox
          v-model="closedDays"
          :native-value="6">
          星期六
        </b-checkbox>
        <b-checkbox
          v-model="closedDays"
          :native-value="7">
          星期日
        </b-checkbox>
      </b-field>
      <transition name="fade">
        <div
          v-if="showAdvancedSetting"
          class="store-form__advanced-fields">
          <b-field
            horizontal
            class="store-form__payment-method-field"
            label="收款方式">
            <b-checkbox
              v-for="method in paymentMethodMapping"
              v-model="currentStore.store_payment_way[method.key]"
              :native-value="method.key"
              :key="method.key">
              {{ method.title }}
            </b-checkbox>
          </b-field>
          <b-field
            horizontal
            class="store-form__payment-time-field"
            label="結款時間">
            <b-checkbox
              v-for="timing in paymentTimingMapping"
              v-model="currentStore.store_payment_way[timing.key]"
              :native-value="timing.key"
              :key="timing.key">
              {{ timing.title }}
            </b-checkbox>
          </b-field>
          <b-field
            horizontal
            label="標籤">
            <b-taginput
              v-model="storeTags"
              aria-close-label="移除此標籤"
              ellipsis
              icon="plus-circle"
              placeholder="建立標籤"
              ref="createTag"
            >
            <template #selected="props">
              <b-tag
                v-for="(tag, index) in props.tags"
                :key="`tag-${tag}-${index}`"
                closable
                rounded
                type="is-primary-light"
                @close="$refs.createTag.removeTag(index, $event)"
              >
                {{ tag }}
              </b-tag>
            </template>
            </b-taginput>
          </b-field>
          <b-field
            horizontal
            label="備註">
            <b-input
              v-model="currentStore.store_detail.note"
              type="textarea"
              placeholder="可以記錄關於餐廳的點點滴滴，例如送餐慢、優惠方案" />
          </b-field>
        </div>
      </transition>

      <div
        v-if="v$.$anyDirty"
        class="is-flex is-justify-content-right mt-2">
        <w-button
          :disabled="v$.$invalid"
          size="sm"
          @click="saveStore">儲存</w-button>
      </div>

      <div class="store-form__collapse">
        <a
          href="#"
          class="store-form__collapse--trigger"
          @click.prevent="showAdvancedSetting = !showAdvancedSetting">
          <i :class="showAdvancedSetting ? 'icon-up-chevron' : 'icon-down-chevron'" />
          <template v-if="showAdvancedSetting">
            收合細節
          </template>
          <template v-else>
            查看更多細節！
          </template>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import StoreForm from './StoreForm';

export default StoreForm;
</script>

<style lang="scss" scoped>
@import './StoreForm';
</style>
